import React, { useEffect, useState } from 'react';
import { Dropdown, Badge, Button, Spinner } from 'react-bootstrap';
import { useNotifications } from '../api/notifications/store';
import { ReactComponent as BellIcon } from '../svgs/bell.svg';
import './../css/NotificationBell.css';
import { useNavigate } from 'react-router';

const NotificationBell: React.FC = () => {
    const {
        notifications,
        unreadCount,
        loading,
        getNotifications,
        getUnreadCount,
        markRead,
        markAllRead,
        startPolling,
        stopPolling
    } = useNotifications();

    // currentCompany is a string in the auth store
    const navigate = useNavigate();
    const [show, setShow] = useState(false);

    useEffect(() => {
        startPolling();
        return () => stopPolling();
    }, [startPolling, stopPolling]);

    const handleToggle = (isOpen: boolean) => {
        setShow(isOpen);
        if (isOpen) {
            getNotifications();
            getUnreadCount();
        }
    };

    const handleNotificationClick = (notif: any) => {
        markRead(notif.id);
        if (notif.link) {
            navigate(notif.link);
        }
        setShow(false);
    };

    const formatTime = (timestamp: number) => {
        const date = new Date(timestamp * 1000);
        const now = new Date();
        const diff = Math.floor((now.getTime() - date.getTime()) / 1000);

        if (diff < 60) return 'Just now';
        if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
        if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
        return date.toLocaleDateString();
    };

    return (
        <Dropdown show={show} onToggle={handleToggle} align="end" className="notification-dropdown">
            <Dropdown.Toggle as="div" className="bell-container">
                <BellIcon className={`bell-icon ${unreadCount > 0 ? 'ringing' : ''}`} />
                {unreadCount > 0 && (
                    <Badge pill bg="danger" className="notification-badge">
                        {unreadCount > 99 ? '99+' : unreadCount}
                    </Badge>
                )}
            </Dropdown.Toggle>

            <Dropdown.Menu className="notification-menu shadow-lg">
                <div className="notification-header d-flex justify-content-between align-items-center">
                    <h6 className="mb-0">Notifications</h6>
                    {unreadCount > 0 && (
                        <Button variant="link" size="sm" onClick={() => markAllRead()} className="p-0 mark-all-read">
                            Mark all as read
                        </Button>
                    )}
                </div>

                <div className="notification-list">
                    {loading && notifications.length === 0 ? (
                        <div className="text-center p-4">
                            <Spinner animation="border" size="sm" variant="primary" />
                        </div>
                    ) : notifications.length === 0 ? (
                        <div className="text-center p-4 text-muted">
                            <p className="mb-0">No notifications</p>
                        </div>
                    ) : (
                        notifications.map((notif) => (
                            <Dropdown.Item
                                key={notif.id}
                                className={`notification-item ${!notif.read ? 'unread' : ''}`}
                                onClick={() => handleNotificationClick(notif)}
                            >
                                <div className="d-flex w-100">
                                    <div className={`notification-icon-type ${notif.type}`}></div>
                                    <div className="flex-grow-1 ms-2">
                                        <div className="d-flex justify-content-between align-items-start">
                                            <span className="notification-title">{notif.title}</span>
                                            <span className="notification-time">{formatTime(notif.created_at)}</span>
                                        </div>
                                        <p className="notification-content mb-0">{notif.content}</p>
                                    </div>
                                    {!notif.read && <div className="unread-dot"></div>}
                                </div>
                            </Dropdown.Item>
                        ))
                    )}
                </div>

                {notifications.length > 0 && (
                    <div className="notification-footer text-center">
                    </div>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default NotificationBell;
